/**
 * Page Account
 * 
 * @module page-account
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'page-account';

if (!customElements.get(customElements.component)) {

    class pageAccount extends HTMLElement {

        constructor() {

            super();

            this.checkHashUrl();
            this.initEvents();
            this.activateMenu();
        }

        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            // Init events to click on the menu links
            this.initClickLinks();

            // Init events to click on the menu links
            this.initCustomerListener();
        }

        /**
         * Listen the customers update their data
         * 
         * @return {undefined}
         */
        initCustomerListener() {

            // Select update button to active the form
            let updateButton = this.querySelector('[data-account-update-button]');
            let customrDetailsDiv = this.querySelector('[data-account-customer-details]');

            // Select the form
            let form = this.querySelector('[data-account-form-details]');

            if(!form) return false;

            if(!updateButton) return false;

            form.addEventListener('submit', event => {
                event.preventDefault();

                if(event.submitter.name == "cancel") {
                    form.classList.add("hidden");
                    customrDetailsDiv.classList.remove("hidden"); 
                }
                else {
                    this.updateCustomerData(event);
                }
            });

            updateButton.addEventListener('click', event => {
                event.preventDefault();
                form.classList.remove("hidden");
                customrDetailsDiv.classList.add("hidden"); 
            });
        }

        /**
         * Update customer data
         * 
         * @param {object} event form submit event.
         * @return {undefined}
         */
        updateCustomerData(event) {
            let accessToken = event.currentTarget.dataset.accountFormToken;
            let apiVersion = event.currentTarget.dataset.accountFormApi;
            let customerId = event.currentTarget.dataset.accountFormCustomer;

            if(accessToken && apiVersion && customerId) {

                let firstName = event.currentTarget.elements[0].value;
                let lastName = event.currentTarget.elements[1].value;
                let email = event.currentTarget.elements[2].value;

                if(firstName && lastName && email) {

                    var customerdata = {
                        customer: {
                          id: customerId,
                          first_name: firstName,
                          last_name: lastName,
                          email: email
                        }
                      };

                    let request = {
                        method: 'PUT',
                        headers: {
                          'Access-Control-Allow-Origin':'*',
                          'Content-Type': 'application/json;',
                          'X-Shopify-Access-Token': accessToken
                        },
                        body: JSON.stringify(customerdata)
                    };

                    let shopURL = event.currentTarget.dataset.accountFormShopUrl;
                    let url = shopURL + "/admin/api/" + apiVersion + "/customers/" + customerId +".json";

                    // Send request
                    fetch(url, request).then(function(response) {
                        return response.json();
                      }).then(function(json) {
      
                        if (json.status && json.status !== 200) {
                          var error = new Error(json.description);
                          error.isFromServer = true;
                          throw error;
                        }
      
                        // Reload page
                        location.reload();
            
                      }).catch(function(error) {
                        console.log(error);
                    });
                }
            }
        }

        /**
         * Init menu click links
         * 
         * @returns {undefined}
         */
        initClickLinks() {

            // Select option for desktop
            let items = this.querySelectorAll('[data-account-sidebar-link]');

            if(!items) return;

            items.forEach((item) => {

                item.addEventListener('click', event => {

                    if(event.currentTarget.dataset.accountSidebarLink) {
                        this.hideAllOptions();
                        this.showSidebarItem(event.currentTarget.dataset.accountSidebarLink);
                        this.showSection(event.currentTarget.dataset.accountSidebarLink);
                    }
                });
            });

            // Select option for mobile
            let select = this.querySelector('[data-account-list-mobile]');

            if(!select) return;

            select.addEventListener("change", event => {
                this.hideAllOptions();
                this.showSidebarItem((select.value).replace("#", ''));
                this.showSection((select.value).replace("#", ''));
            });
        }

        /**
         * Check the current URL
         * 
         * @return {undefined}
         */
        checkHashUrl() {
            var hash = window.location.hash;

            if(hash == "#orders" || hash == "#addresses"  || hash == "#details" ) {
                this.showSection(hash.replace("#", ''));
                this.showSidebarItem(hash.replace("#", ''));
            }
            else {
                this.enableFirstElement();
            }
        }

        /**
         * Enable first element
         * 
         * @return {undefined}
         */
        enableFirstElement() {

            window.location.hash = '#orders';
            this.showSidebarItem('orders');
            this.showSection('orders');
        }

        /**
         * Show section
         * 
         * @param {string} id section id.
         * @return {undefined}
         */
        showSection(id) {

            let section = this.querySelector(`[data-section="${id}"]`);

            if(!section) return;

            section.classList.remove('hidden');
        }

        /**
         * Show sidebar item (both devices)
         * 
         * @param {string} id section id.
         * @return {undefined}
         */
        showSidebarItem(id) {

            // Desktop
            let sidebarItem = this.querySelector(`[data-account-sidebar-item="${id}"]`);

            if(!sidebarItem) return;

            sidebarItem.classList.add("active");

            // Mobile
            let select = this.querySelector(`[data-account-list-mobile]`);

            if(!select) return;

            select.value = '#' + id;
        }

        /**
         * Hide all options (sections and sidebar)
         * 
         * @return {undefined}
        */
        hideAllOptions() {

            let sections = this.querySelectorAll('[data-section]');

            if(!sections) return;

            sections.forEach((section) => {
                section.classList.add('hidden');
            });

            let sidebarItems = this.querySelectorAll('[data-account-sidebar-item]');

            if(!sidebarItems) return;

            sidebarItems.forEach((item) => {
                item.classList.remove('active');
            });
        }

        /**
         * Check the current URL and Add a class to the current li
         * 
         * @return {undefined}
         */
         activateMenu(){
            var hash = window.location.hash;
            const element = document.querySelector(`[data-account-sidebar-item="${hash}"]`)
            if(element) {
                element.classList.add('active')
            }
        }
    }

    customElements.define(customElements.component, pageAccount);
}